export const initialState: any = {
  CategoryType: -1,
  MediaTopMargin: 0,
  MediaLeftMargin: 0
};
